<template>
  <div class="tw-bg-white tw-py-4 tw-rounded tw-border tw-border-solid tw-border-gray-200 tw-h-[220px]">
    <div class="tw-flex tw-items-center tw-mb-6 tw-gap-3 tw-px-4">
      <div class="tw-flex tw-items-center tw-gap-2">
        <p class="tw-p-2x tw-font-bold tw-text-lg">{{ $t('common.leads-per-day') }}</p>
        <p class="tw-px-1 tw-bg-emerald-600 tw-text-white tw-text-sm tw-rounded">{{ new Intl.NumberFormat().format(total) }}</p>
      </div>
    </div>
    <apexchart 
      type="area" 
      height="140" 
      :options="options" 
      :series="series"
    ></apexchart>
  </div>
</template>

<script setup>
import { ref, computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { marketer } from '@/api/dashboard';

const { t } = useI18n();
const loading = ref(true);
// Demo data - converting cost_per_lead to leads values
const data = ref([
  // { date: "2025-05-10", leads: 45 },
  // { date: "2025-05-12", leads: 62 },
  // { date: "2025-05-14", leads: 73 },
  // { date: "2025-05-16", leads: 39 },
  // { date: "2025-05-20", leads: 42 },
  // { date: "2025-05-21", leads: 40 },
  // { date: "2025-05-22", leads: 43 },
  // { date: "2025-05-23", leads: 40 },
  // { date: "2025-05-24", leads: 42 },
  // { date: "2025-05-26", leads: 39 },
  // { date: "2025-05-27", leads: 52 },
  // { date: "2025-05-28", leads: 41 },
  // { date: "2025-05-29", leads: 46 },
  // { date: "2025-05-30", leads: 40 },
  // { date: "2025-05-31", leads: 42 }
]);

// Calculations
const total = computed(() => data.value.reduce((acc, curr) => acc + curr.leads, 0));

// Chart configuration
const options = computed(() => ({
  chart: {
    type: 'area',
    toolbar: { show: false },
    zoom: { enabled: false },
    foreColor: '#64748b'
  },
  colors: ['#10B981'],
  dataLabels: { 
    enabled: true,
    style: {
      fontSize: '10px',
      fontFamily: 'Inter, sans-serif',
      colors: ['#fff']
    },
    background: {
      enabled: true,
      foreColor: '#10B981',
      padding: 4,
      borderRadius: 8,
      borderWidth: 0,
      opacity: 0.9,
    }
  },
  stroke: {
    width: 2,
    curve: 'smooth'
  },
  fill: {
    type: 'gradient',
    gradient: {
      shadeIntensity: 0.3,
      opacityFrom: 0.6,
      opacityTo: 0.1,
      stops: [0, 90, 100],
      colorStops: [
        [
          {
            offset: 0,
            color: '#10B981',
            opacity: 0.6
          },
          {
            offset: 100,
            color: '#10B981',
            opacity: 0.1
          }
        ]
      ]
    }
  },
  xaxis: {
    type: 'datetime',
    labels: {
      style: {
        fontSize: '11px',
        fontFamily: 'Inter, sans-serif',
        fontWeight: 500,
      },
      format: 'MMM d',
      datetimeUTC: false
    },
    axisTicks: { show: false }
  },
  yaxis: { show: false },
  grid: {
    borderColor: '#f1f5f9',
    strokeDashArray: 4,
    padding: { top: 0, right: 20, bottom: 0, left: 20 }
  },
  tooltip: {
    theme: 'light',
    style: {
      fontSize: '12px',
      fontFamily: 'Inter, sans-serif'
    },
    x: {
      format: 'MMM d, yyyy'
    },
    marker: {
      fillColors: ['#10B981']
    }
  }
}));

// Data format for datetime series
const series = computed(() => [{
  name: t('common.leads'),
  data: data.value.map(i => ({
    x: new Date(i.date).getTime(),
    y: i.leads
  }))
}]);

const getData = async () => {
    loading.value = true;
  await marketer.leadsPerDay()
  .then(res => {
        data.value = res.data;
  })
  .catch(err => {
    console.log(err);
  })
  loading.value = false;
}

getData();
</script>

<style scoped>
.tw-bg-emerald-600 {
  background-color: #10B981;
}
</style> 